import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react'
import {connect} from 'react-redux';
import CategoryMenu from './CategoryMenu'
import {userActions} from '../actions/userActions';
import {Link} from 'react-router-dom'
import Sidebar from './sidebar/Sidebar';
import Footer from './Footer'
import PerfectScrollbar from 'react-perfect-scrollbar';
import './../css/base.css';
import './../helpers/importCSS';
import logo from './../img/ab_logo4.png';
import ErrorBoundary from "../ErrorBoundary";
import Navbar from "./Navbar";
import AdminTools from "./admin-tools/AdminTools"

class Template extends React.Component {

    constructor(props) {
        super(props);
        this.clickLogOut = this.clickLogOut.bind(this);
        this._scrollBarRef = React.createRef();
    }

    clickLogOut() {
        this.props.logout()
    }

    render() {
        const {user} = this.props;
        const {alert} = this.props;

        return <React.Fragment>
            <header>
                <Navbar clickLogOut={this.clickLogOut}  mfgId={user.addr} />
            </header>
            <main>
                <ErrorBoundary>
                    {alert.message &&
                    <div className={`alert ${alert.type}`} dangerouslySetInnerHTML={{__html: alert.message}}></div>
                    }
                    {this.props.children}
                </ErrorBoundary>
            </main>
            <Footer/>
        </React.Fragment>
    } 
}

const mapState = (state) => {
    const {alert, user} = state;
    return {alert, user};
};

const actionCreators = {
    logout: userActions.logout,
};

export default connect(mapState, actionCreators)(Template);
